import React, { useEffect, useState ,useRef} from 'react'

function ImageData({ imgLink }) {

    const [formte,setformat]=useState('')

   useEffect(()=>{
       let x=imgLink.slice(-3);
       setformat(x.toUpperCase())
       
   },[imgLink])






  

    return (
        <div>
            {
                formte=='JPG' || formte=='PEG' || formte=='PNG' || formte=='SVG' || formte=='EBP' || formte=='GIF'? <img className='imgg' src={imgLink}></img>:<p></p>
            }

            {
                formte=='MP4' ||formte=='3GP' ||formte=='AVI' ||formte=='MKV' ||formte=='MOV' ||formte=='WMV' || formte=='FLV' || formte=='3GP' || formte=='3G2' || formte=='OGG' || formte=='CHD' || formte=='RES' || formte=='IVX' || formte=='VID' || formte=='EBM' ||formte=='MP3' ?  <video  className='video' width='94%' height="260" preload="metadata" autoplay  loop muted controls src={imgLink} type="video/mp4">
                           <source src="movie.ogg" type="video/ogg"/> </video> :<p></p>
            }

            {
                formte=='PDF' ? <embed src={imgLink} type="application/pdf" width="90%" height="500px"></embed>:<p></p>
            }
            
            {
                formte=='OCX' ? <iframe src={imgLink} width="90%" height="500px" allowfullscreen webkitallowfullscreen></iframe>:<p></p>
            }

                </div>
                )
}

                export default ImageData
